export enum InteractionStatusId {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Delivered = 'delivered',
  Pending = 'pending',
  Expired = 'expired',
  Ordered = 'ordered',
  InProgress = 'in-progress',
  NotStarted = 'not-started',
  Removed = 'removed',
  DelegatedToRemote = 'delegated-to-remote',
}

export enum TransmissionStatusId {
  Failure = 'failure',
  InvalidState = 'invalid-state',
  Success = 'success',
}
